import apiClient from '../../../services/api-client'
import type {
  SurveyQuestion,
  CreateQuestionRequest,
  UpdateQuestionRequest,
  ListQuestionsResponse
} from '../types/survey.types'

export async function getQuestions(surveyId: string): Promise<SurveyQuestion[]> {
  const response = await apiClient.get<ListQuestionsResponse>(`/survey/${surveyId}/questions`)
  return response.data.data
}

export async function createQuestion(surveyId: string, request: CreateQuestionRequest): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>(`/survey/${surveyId}/questions`, { surveyId, ...request })
  return response.data
}

export async function updateQuestion(surveyId: string, id: string, request: UpdateQuestionRequest): Promise<void> {
  await apiClient.put(`/survey/${surveyId}/questions/${id}`, { ...request, id })
}

export async function deleteQuestion(surveyId: string, id: string): Promise<void> {
  await apiClient.delete(`/survey/${surveyId}/questions/${id}`)
}
